import { TranslateService } from '@ngx-translate/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

class CustomPaginator {
  static customPaginatorIntl: MatPaginatorIntl;
}

export function CustomPaginatorFactory(translateService: TranslateService): MatPaginatorIntl {
  if (!CustomPaginator.customPaginatorIntl) {
    const customPaginatorIntl = new MatPaginatorIntl();
    customPaginatorIntl.itemsPerPageLabel = translateService.instant('common.list.itemPerPage');
    translateService.onLangChange.subscribe(() => {
      customPaginatorIntl.itemsPerPageLabel = translateService.instant('common.list.itemPerPage');
    });
    CustomPaginator.customPaginatorIntl = customPaginatorIntl;
  }

  return CustomPaginator.customPaginatorIntl;
}
